const SecurityConstants = {
  DEVTOOLS_DETECTION_ENABLED: false,
};

export default SecurityConstants;